export default __webpack_public_path__ + "static/screen-web@2x-b31374932bdce0a14a51f16f82c6f56e.webp";